import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import ServerTable from "../../components/atoms/tables/serverTable";
const Communication = () => {
    const navigate = useNavigate();
    const columns = [
        {
            name: "Subject",
            selector: "subject",
            sortable: true,
            sortField: "subject",
        },
        {
            name: "Status",
            selector: "status",
            cell: (row) => (
                <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium firstlettercaps
                 ${row.status === "resolved" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}
                `}>
                    {row.status}
                </span>
            )
        },
        {
            name: "Updated At",
            selector: "updated_at",
            sortable: true,
            sortField: "updated_at",
            cell: (row) => (
                <div className="text-gray-600">{new Date(row.updated_at).toLocaleString()}</div>
            ),
        },
        {
            name: "Actions",
            cell: (row) => (
                <button
                    type="button"
                    onClick={() => navigate(`/communication/${row.uuid}`)}
                    className="inline-flex items-center rounded border border-gray-300 bg-white px-5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                    View
                </button>
            )
        }
    ]
    const [query, setQuery] = useState("");
    const [filters, setFilters] = useState({});
    const [status, setStatus] = useState("all");
    useEffect(() => {
        if (query.length > 0) {
            debounce(() => {
                let q = {
                    query
                }
                if (status !== "all") {
                    q.status = status;
                }
                setFilters(q);
            }, 500)();
        }
        else {
            debounce(() => {
                if (status !== "all") {
                    setFilters({
                        status
                    });
                }
                else {
                    setFilters({});
                }
            }, 500)();
        }
    }, [query, status]);
    return (
        <>

            <div className="mt-1 flex rounded-md shadow-sm">
                <div className="relative flex flex-grow items-stretch focus-within:z-10">
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <input
                        type="search"
                        name="search"
                        onChange={(e) => setQuery(e.target.value)}
                        className={`block w-full mr-px rounded-l-md border-gray-300 hover:border-blue-500 pl-10 focus:border-blue-500 focus:ring-blue-500 sm:text-sm`}
                        placeholder="Search Tickets"
                    />
                </div>
                <div className="ml-px">
                    <select
                        onChange={(e) => setStatus(e.target.value)}
                        class="w-full rounded-r-md border-gray-300 hover:border-blue-500 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm">
                        <option value={"all"}>All</option>
                        <option value={"active"}>Active</option>
                        <option value={"resolved"}>Resolved</option>
                    </select>
                </div>
            </div>
            <div className='mt-4'>
                <ServerTable
                    key={JSON.stringify(filters)}
                    apiURL={'/communication/get'}
                    columns={columns}
                    filters={filters}
                />
            </div>
        </>
    )
}
export default Communication;